import { useCallback } from 'react';
import { usePostHog } from '@posthog/react';

/**
 * Returns a `trackAction` helper that auto-attaches the diagram ID to every
 * PostHog event.
 */
export function useActionTracker(diagramId: string | null) {
  const posthog = usePostHog();

  const trackAction = useCallback(
    (event: string, props?: Record<string, unknown>) => {
      posthog?.capture(event, {
        diagram_id: diagramId,
        ...props,
      });
    },
    [posthog, diagramId],
  );

  return { trackAction };
}
